import {Helmet} from "react-helmet-async";
import {useParams} from "react-router";

import {Redirect} from "@/components/router/Redirect.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {IsItDownDetailsBody} from "@/marketingPages/isitdown/components/isitdowndetailsbody/IsItDownDetailsBody.tsx";

const DOMAIN_RE = /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,}?$/;

export const IsItDownDetailsPage = () => {
  const {slug} = useParams();
  if (!slug || !DOMAIN_RE.test(slug)) {
    return <Redirect url="/not-found" />;
  }
  return (
    <div>
      <Helmet>
        <title>Is {slug} Down?</title>
        <meta
          name="description"
          content={`Check the current website monitoring status of ${slug}, report outages, or other problems with our easy reporting tools. Also, rate ${slug} on their overall website performance`}
        />
      </Helmet>
      <UpErrorBoundary>
        <IsItDownDetailsBody slug={slug} />
      </UpErrorBoundary>
    </div>
  );
};
